var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',[_c('mdb-line-chart',{attrs:{"data":_vm.lineChartData,"options":_vm.lineChartOptions,"width":500,"height":250}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }